// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__wPHtf","center_logo":"Logo_center_logo__xHKLx","logo":"Logo_logo__W1xAy","white-bg":"Logo_white-bg__u4bFu"};